import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var BaseResponse =
/*#__PURE__*/
function () {
  function BaseResponse() {
    _classCallCheck(this, BaseResponse);
  }

  _createClass(BaseResponse, [{
    key: "getHeader",

    /**
     * Returns the value of the specified header
     * @param {string} headerName the header name
     * @returns {string} the header value
     */
    value: function getHeader(headerName) {
      // eslint-disable-line no-unused-vars
      throw new Error('not implemented');
    }
    /**
     * @returns {ArrayBuffer} the response data of the request
     */

  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('not implemented');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "ok",

    /**
     * Returns whether the response has an ok'ish status code
     */
    get: function get() {
      return this.status >= 200 && this.status <= 299;
    }
    /**
     * Returns the status code of the response
     */

  }, {
    key: "status",
    get: function get() {
      throw new Error('not implemented');
    }
  }]);

  return BaseResponse;
}();
export var BaseClient =
/*#__PURE__*/
function () {
  function BaseClient(url) {
    _classCallCheck(this, BaseClient);

    this.url = url;
  }
  /**
   * Send a request with the options
   * @param {object} [options]
   */


  _createClass(BaseClient, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref,
            headers,
            credentials,
            signal,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, credentials = _ref.credentials, signal = _ref.signal;
                throw new Error('request is not implemented');

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);

  return BaseClient;
}();